import CitySEOHead from "@/components/feature/CitySEOHead";
import WinterGardenHeroSection from "./components/HeroSection";
import WinterGardenStickyNav from "./components/StickyNav";
import WinterGardenProcessingTimeSection from "./components/ProcessingTimeSection";
import WinterGardenServicesSection from "./components/ServicesSection";
import WinterGardenLocalAreaSection, { landmarks } from "./components/LocalAreaSection";
import WinterGardenTravelTimingSection from "./components/TravelTimingSection";
import WinterGardenDestinationsSection from "./components/DestinationsSection";
import WinterGardenTestimonialsSection from "./components/TestimonialsSection";
import WinterGardenAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WinterGardenComparisonSection from "./components/ComparisonSection";
import WinterGardenMistakesSection from "./components/MistakesSection";
import WinterGardenHowItWorksSection from "./components/HowItWorksSection";
import WinterGardenFAQSection, { faqs } from "./components/FAQSection";
import WinterGardenHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WinterGardenFinalCTA from "./components/FinalCTA";

const areaServedList = [
  { "@type": "City", name: "Winter Garden" },
  { "@type": "City", name: "Windermere" },
  { "@type": "City", name: "Ocoee" },
  { "@type": "City", name: "Oakland" },
  { "@type": "City", name: "Horizon West" },
  { "@type": "City", name: "Clermont" },
  { "@type": "City", name: "Dr. Phillips" },
  { "@type": "AdministrativeArea", name: "Orange County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Winter Garden, Windermere, Ocoee, and Orange County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WinterGardenPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Winter Garden"
        state="Florida"
        stateAbbr="FL"
        route="/winter-garden"
        title="Emergency Passport Winter Garden, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Winter Garden, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Orange County families, medical professionals, and travelers."
        geoPlacename="Winter Garden, Florida"
        geoPosition="28.5653;-81.5862"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Florida"
        statePageRoute="/states/florida"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={landmarks}
      />
      <WinterGardenHeroSection />
      <WinterGardenStickyNav />
      <WinterGardenProcessingTimeSection />
      <WinterGardenLocalAreaSection />
      <WinterGardenServicesSection />
      <WinterGardenTravelTimingSection />
      <WinterGardenDestinationsSection />
      <WinterGardenTestimonialsSection />
      <WinterGardenAcceptanceFacilitiesSection />
      <WinterGardenComparisonSection />
      <WinterGardenMistakesSection />
      <WinterGardenHowItWorksSection />
      <WinterGardenFAQSection />
      <WinterGardenHelpfulResourcesSection />
      <WinterGardenFinalCTA />
    </div>
  );
}